import ShortCutDisplay from "../../../../src/components/ShortcutDisplay";
import PolypaneIntro from "../../../../src/components/PolypaneIntro";
import unusedcss from "../../../../assets/images/blogs/pp271/unused-css.png";
import computedfilter from "../../../../assets/images/blogs/pp271/computedfilter.png";
import cmdtooltip from "../../../../assets/images/blogs/pp271/cmdtooltip.png";
import constructedstylesheet from "../../../../assets/images/blogs/pp271/constructedstylesheet.png";
import bookmarkfilter from "../../../../assets/images/blogs/pp271/bookmarkfilter.png";
import projectsettings from "../../../../assets/images/blogs/pp271/projectsettings.png";
import showprojectselector from "../../../../assets/images/blogs/pp271/showprojectselector.png";
import deleteconfirmationfolder from "../../../../assets/images/blogs/pp271/deleteconfirmationfolder.png";
import pausedtracking from "../../../../assets/images/blogs/pp271/pausedtracking.png";
import activetracking from "../../../../assets/images/blogs/pp271/activetracking.png";
import roleimg from "../../../../assets/images/blogs/pp271/roleimg.png";
import consolepp271 from "../../../../assets/videos/blogs/pp271/console.mp4";
import snippetspp271 from "../../../../assets/videos/blogs/pp271/snippets.mp4";
import * as React from 'react';
export default {
  ShortCutDisplay,
  PolypaneIntro,
  unusedcss,
  computedfilter,
  cmdtooltip,
  constructedstylesheet,
  bookmarkfilter,
  projectsettings,
  showprojectselector,
  deleteconfirmationfolder,
  pausedtracking,
  activetracking,
  roleimg,
  consolepp271,
  snippetspp271,
  React
};